import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD4UK5ojjAj_kKyIjXTvkRUNCzLUnng0u0",
  authDomain: "klinik-begleiter24.firebaseapp.com",
  projectId: "klinik-begleiter24",
  storageBucket: "klinik-begleiter24.firebasestorage.app",
  messagingSenderId: "358390061140",
  appId: "1:358390061140:web:022c8a55d95d58622d75c1",
  measurementId: "G-D6P0WKCQSS"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
